/* ============================= */
/* VERSION V1.1 - NAVBAR.JSX */
/* ============================= */
import React, { useState, useEffect } from "react";
import "../styles/Navbar.css";
import logo from "../assets/logo/logo-taxi-de-la-douce.svg";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <header className={`navbar-wrapper ${scrolled ? "navbar-scrolled" : ""}`}>
      <nav className="navbar" aria-label="Navigation principale">
        {/* Logo */}
        <a href="#hero" className="navbar-brand" onClick={closeMenu}>
          <img
            src={logo}
            alt="Taxi de la Douce"
            className="navbar-logo"
            loading="eager"
            decoding="async"
          />
        </a>

        {/* Links */}
        <div className={`nav-links ${open ? "active" : ""}`}>
          <a href="#hero" onClick={closeMenu}>Accueil</a>
          <a href="#apropos" onClick={closeMenu}>À propos</a>
          <a href="#services" onClick={closeMenu}>Services</a>
          <a href="#contact" onClick={closeMenu}>Contact</a>
          <a
            href="#reservation"
            onClick={closeMenu}
            className="btn btn-primary"
            aria-label="Pré-réserver un taxi"
          >
            🚖 Pré-réservation
          </a>
        </div>

        {/* Mobile Button */}
        <button
          className="hamburger"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? "✖" : "☰"}
        </button>
      </nav>
    </header>
  );
};

export default Navbar;









